import { ComponentProps, ReactNode, useContext } from 'react';
import clsx from 'clsx';
import { OpRadio } from 'components/customAntd/DLS/OpRadio/OpRadio';
import { OpSkeleton } from 'components/customAntd/DLS/OpSkeleton/OpSkeleton';
import { OpFormContext } from '../../OpFormContext';
import { OpForm } from '../../OpForm';

import './OpFormRadio.scss';

interface IOpFormRadio
  extends Pick<
      ComponentProps<typeof OpForm.Item>,
      'name' | 'label' | 'tooltip'
    >,
    Omit<ComponentProps<typeof OpRadio>, 'name' | 'tooltip'> {
  formItemClassName?: string;
  isLoading?: boolean;
  radioTooltip?: ReactNode;
}

export const OpFormRadio = ({
  // Form Item props
  formItemClassName,
  name,
  label,
  tooltip,

  // For skeleton loading state
  isLoading,

  // Wrapped element props
  children,
  radioTooltip,

  disabled,
  ...elementProps
}: IOpFormRadio) => {
  /** The Form is wrapped in a provider that passes the loading context
   *  to the component */
  const { isDataLoading, isReadOnly } = useContext(OpFormContext);

  return (
    <OpForm.Item
      className={clsx('op-form-radio', formItemClassName)}
      name={name}
      tooltip={tooltip}
      label={label}
      valuePropName="checked"
    >
      {isDataLoading || isLoading ? (
        <OpSkeleton.Avatar active size="small" shape="circle" />
      ) : (
        <OpRadio
          disabled={isReadOnly || disabled}
          tooltip={radioTooltip}
          {...elementProps}
        >
          {children}
        </OpRadio>
      )}
    </OpForm.Item>
  );
};
